'use strict';
import {module} from '../app';

module.service('enums', [function () {
  let self = this;

  self.statuses = ['New', 'SurveyStarted', 'SurveyFinished', 'ExamWaiting', 'ExamInProgress', 'ExamPaused', 'ExamStopped', 'ExamIncomplete', 'Finished', 'UltrasoundRequested', 'RISWaiting'];

  self.examTypes = ['Mammography', 'Ultrasound', 'Tomosynthesis', 'Ductography', 'Breast MRI', 'Bone Densitometry', 'Lung', 'Other'];

  self.examShortCodeTypes = ['Mammo', 'US', 'Tomo', 'Duct.', 'MRI', 'Dexa', 'Lung', 'Other'];

  self.visitTypes = [{code: 'D', label: 'Diagnostic'}, {code: 'A', label: 'Additional evaluation'}, {
    code: 'S',
    label: 'Screening'
  }];
  self.allStatusGroups = [{
    name: 'Patient Survey',
    statuses: ['New', 'SurveyStarted', 'SurveyFinished'],
    key: 'New',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Waiting for Exam',
    statuses: ['ExamWaiting'],
    key: 'ExamWaiting',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Performing Exam',
    statuses: ['ExamInProgress', 'ExamPaused', 'ExamIncomplete', 'Finished'],
    key: 'ExamInProgress',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Exam Ended',
    statuses: ['ExamStopped'],
    key: 'ExamStopped',
    onlyForRoles: ['Technologist', 'Radiologist']
  }, {
    name: 'Ultrasound Request',
    statuses: ['UltrasoundRequested', 'RISWaiting'],
    key: 'UltrasoundRequested',
    onlyForRoles: ['UltrasoundTechnologist']
  }];

  self.worklistStatuses = {
    New: 'New',
    SurveyStarted: 'SurveyStarted',
    SurveyFinished: 'SurveyFinished',
    ExamWaiting: 'ExamWaiting',
    ExamInProgress: 'ExamInProgress',
    ExamPaused: 'ExamPaused',
    ExamStopped: 'ExamStopped',
    ExamIncomplete: 'ExamIncomplete',
    Finished: 'Finished',
    UltrasoundRequested: 'UltrasoundRequested',
    RISWaiting: 'RISWaiting',
    TakeExam: 'TakeExam',
    ReviewComplete: 'ReviewComplete'
  };

  self.FUReasons = {
    Refused: 'R',
    FollowedElsewhere: 'E',
    LostContact: 'L',
    PatientDeceased: 'D',
    Internal: 'I',
    ResolvedAfterLastLetter : '4'
  };

  self.worklistAdditionalInfos = {
    ReleasePatient: 'ReleasePatient',
    AdditionalImaging: 'AdditionalImaging',
    UltrasoundRequested: 'UltrasoundRequested',
    Other: 'Other'
  };

}]);



// WEBPACK FOOTER //
// ./src/scripts/services/enums.js